var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{staticStyle:{"margin-top":"20px"},attrs:{"current-page":_vm.pageNo,"page-size":_vm.pageSize,"page-sizes":[10, 50, 100,200],"total":_vm.total,"align":"right","background":"","layout":" total,prev,pager,next,sizes,jumper"},on:{"current-change":_vm.currentChanged,"size-change":_vm.sizeChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }